/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/* Template custom: api */

import {
  ApiGetHubSettingsByUrlDto,
  ApiHubSettingsResponseDto,
} from "./data-contracts";
import {
  ApiBaseError,
  ContentType,
  HttpClient,
  RequestParams,
} from "./http-client";

export class HubSettings<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /* Template custom: procedure-call */
  /**
   * @description Get hub settings
   *
   * @tags Hub settings
   * @name HubSettingsControllerGetHubSettings
   * @summary Get hub settings
   * @request GET:/hub-settings
   * @secure
   * @response `200` `(ApiHubSettingsResponseDto)[]` OK
   * @response `403` `void` Forbidden
   * @response `404` `void` Not Found
   */
  hubSettingsControllerGetHubSettings = (params: RequestParams = {}) =>
    this.request<ApiHubSettingsResponseDto[], ApiBaseError>({
      path: `/hub-settings`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Get hub settings by url
   *
   * @tags Hub settings
   * @name HubSettingsControllerGetHubSettingsByUrl
   * @summary Get hub settings by url
   * @request GET:/hub-settings/by-url
   * @secure
   * @response `200` `ApiHubSettingsResponseDto` OK
   * @response `403` `void` Forbidden
   * @response `404` `void` Not Found
   */
  hubSettingsControllerGetHubSettingsByUrl = (
    data: ApiGetHubSettingsByUrlDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiHubSettingsResponseDto, ApiBaseError>({
      path: `/hub-settings/by-url`,
      method: "GET",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Get all hub settings
   *
   * @tags Hub settings
   * @name HubSettingsControllerGetAllHubSettings
   * @summary Get all hub settings
   * @request GET:/hub-settings/all
   * @secure
   * @response `200` `(ApiHubSettingsResponseDto)[]` OK
   */
  hubSettingsControllerGetAllHubSettings = (params: RequestParams = {}) =>
    this.request<ApiHubSettingsResponseDto[], ApiBaseError>({
      path: `/hub-settings/all`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
}
